export function LeftSection(
  activeSection: string | null,
  handleItemClick: (sectionId: string) => void,
) {
  return (
    <div className="left-section">
      <ul id="nav-list">
        <li
          data-section="serviceDetailsHeading"
          className={activeSection === "serviceDetailsHeading" ? "active" : ""}
          onClick={() => handleItemClick("serviceDetailsHeading")}
        >
          Service Details
        </li>
        <li
          data-section="requestingProviderHeading"
          className={
            activeSection === "requestingProviderHeading" ? "active" : ""
          }
          onClick={() => handleItemClick("requestingProviderHeading")}
        >
          Requesting Provider
        </li>
        <li
          data-section="subscriberHeading"
          className={activeSection === "subscriberHeading" ? "active" : ""}
          onClick={() => handleItemClick("subscriberHeading")}
        >
          Subscriber
        </li>
        <li
          data-section="patientHeading"
          className={activeSection === "patientHeading" ? "active" : ""}
          onClick={() => handleItemClick("patientHeading")}
        >
          Patient
        </li>
        <li
          data-section="diagnosesHeading"
          className={activeSection === "diagnosesHeading" ? "active" : ""}
          onClick={() => handleItemClick("diagnosesHeading")}
        >
          Diagnosis
        </li>
        <li
          data-section="renderingProvidersHeading"
          className={
            activeSection === "renderingProvidersHeading" ? "active" : ""
          }
          onClick={() => handleItemClick("renderingProvidersHeading")}
        >
          Rendering Provider
        </li>
        <li
          data-section="proceduresHeading"
          className={activeSection === "proceduresHeading" ? "active" : ""}
          onClick={() => handleItemClick("proceduresHeading")}
        >
          Procedures
        </li>
      </ul>
    </div>
  );
}
